import { Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import { LoginComponent } from './shared/components/login/login.component'
import { HomeComponent } from './pages/home/home.component'
import { RefreshGuard } from './shared/services/refresh-guard.service'

export const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboards.component').then(m => m.DashboardsComponent),
    canActivate: [MsalGuard, RefreshGuard],
  },
  {
    path: 'dashboard/:companyId',
    loadComponent: () => import('./pages/dashboard/dashboards.component').then(m => m.DashboardsComponent),
    canActivate: [MsalGuard, RefreshGuard],
  },
  {
    path: 'dashboard/:companyId/:dashboardId',
    loadComponent: () => import('./pages/dashboard/dashboards.component').then(m => m.DashboardsComponent),
    canActivate: [MsalGuard, RefreshGuard],
  },
  {
    path: 'training',
    loadComponent: () => import('./pages/training/training.component').then(m => m.TrainingComponent),
    canActivate: [MsalGuard, RefreshGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard, RefreshGuard],
  },
  {
    path: 'auth',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: ':companyId',
    loadComponent: () => import('./pages/dashboard/dashboards.component').then(m => m.DashboardsComponent),
    canActivate: [MsalGuard, RefreshGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  },
]
